import ERRCODES from '@/utils/error-codes'

export default {
  methods: {
    validate (row) {
      const outErrors = []

      const shortName = row.shortName
      const officialName = row.officialName
      const checkForSpaceOfficialName = officialName.split(' ')
      const checkForSpaceShortName = shortName.split(' ')

      const officialNameMinLen = 10
      const officialNameMaxLen = 1000
      const shortNameMinLen = 10
      const shortNameMaxLen = 1000

      if (officialName.length <= officialNameMinLen) {
        outErrors.push(ERRCODES.organization.officialNameMinLen)
      } else if (officialName.length > officialNameMaxLen) {
        outErrors.push(ERRCODES.organization.officialNameMaxLen)
      }

      if (shortName.length <= shortNameMinLen) {
        outErrors.push(ERRCODES.organization.shortNameMinLen)
      } else if (shortName.length > shortNameMaxLen) {
        outErrors.push(ERRCODES.organization.shortNameMaxLen)
      }

      if (outErrors.length === 0 &&
          checkForSpaceOfficialName[0] !== checkForSpaceShortName[0]) {
        outErrors.push(ERRCODES.organization.shortNameNeqOfficialName)
      }

      return outErrors
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/organizations/Validate.mixin.js